import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useState } from 'react';
import { useStore } from 'src/stores';
import { useDebounce } from 'src/utils/hooks/useDebounce';
import { collectResidentAccountIds, indexSuggestions } from './suggestionModel';

/** Long enough to let a typed amount or a picked date settle, short enough to feel immediate. */
const REQUEST_DEBOUNCE_MS = 400;
const EMPTY_STATE = {
  hasFailed: false,
  isLoading: false,
  suggestions: {}
};

/**
 * Asks the allocation service what the given bill values would allocate to, keyed by property and
 * utility. The call writes nothing, so it is safe to repeat on every edit: requests are debounced and
 * a newer one cancels the one in flight. Resident names are fetched for whoever the answer mentions.
 */
export function useAllocationSuggestions(items) {
  const store = useStore();
  const _useState = useState(EMPTY_STATE),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  // The requests themselves are the dependency, so a re-render with equal values changes nothing.
  const signature = useDebounce(JSON.stringify(items || []), REQUEST_DEBOUNCE_MS);
  useEffect(() => {
    const requested = JSON.parse(signature);
    if (!requested.length) {
      setState(EMPTY_STATE);
      return undefined;
    }
    let isActive = true;
    setState(current => _objectSpread(_objectSpread({}, current), {}, {
      hasFailed: false,
      isLoading: true
    }));
    store.allocations.postAllocationSuggestionAsync.run({
      items: requested
    }).then(resp => {
      if (!isActive) return;

      // A cancelled request returns nothing, and what is on screen still came from a valid answer.
      if (!resp) return;
      if (!resp.isSuccessful || !resp.response) {
        setState(current => _objectSpread(_objectSpread({}, current), {}, {
          hasFailed: true,
          isLoading: false
        }));
        return;
      }
      const suggestions = resp.response.items || [];
      setState({
        hasFailed: false,
        isLoading: false,
        suggestions: indexSuggestions(suggestions)
      });
      const accountIds = collectResidentAccountIds(suggestions).filter(id => !store.account.profilesFullName.has(id));
      if (accountIds.length) store.account.getUsersProfilesAsync.run({
        accountIds
      });
    });
    return () => {
      isActive = false;
    };
  }, [signature, store]);
  return state;
}